// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"sequence"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M3 5H9V9H3V5Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M15 5H21V9H15V5Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M6 19V9M18 19V9M3 5H9V9H3V5ZM15 5H21V9H15V5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12.6052 18.5L15 16L12.6052 13.5M13.75 16L9 16","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SequenceIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sequence',
    ref,
    icon: element,
  },
));

SequenceIcon.displayName = 'SequenceIcon';

export default SequenceIcon;
